<div style="width:100%;margin-top: 1%;">
  <div class="row eip-form-controls m-0 eip-mt-15">
      <section class="content">
          <div class="container-fluid pl-0 pr-0">
              <div class="block-header">
                  <div class="row m-0">
                      <div class='col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12' *ngIf="!isCommonProject">
                          <mat-button-toggle-group aria-label="Font Style" class="p-0" style="width: 80%;" (change)="changeButtonToggle($event)" [value]="selectedOption">
                              <mat-button-toggle value="standard">Standard Drawing List</mat-button-toggle>
                              <mat-button-toggle value="linkeddoc">Linked Document</mat-button-toggle>
                          </mat-button-toggle-group>
                      </div>
                      <div class='col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12' *ngIf="isCommonProject" style="pointer-events: none;">
                          <mat-button-toggle-group aria-label="Font Style" class="p-0" style="width: 80%;" (change)="changeButtonToggle($event)" [value]="selectedOption">
                              <mat-button-toggle value="standard">Standard Drawing List</mat-button-toggle>
                              <mat-button-toggle value="linkeddoc">Linked Document</mat-button-toggle>
                          </mat-button-toggle-group>
                      </div>
                  </div>
              </div>

              <div [hidden]="!isStandardDraw">
                  <div class="block-header" *ngIf="!isCommonProject">
                      <!-- <div class="row m-0" style="padding-top: 20px;">

                          <div class='col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12'>
                              <form [formGroup]="getworkflow" autocomplete="off">
                                  <EIPAutoComplete TextField="workflowName" ValueField="workflowId" WaterMarkText="Workflow" setId="ddlWorkflow{{docIndex}}" ShowTextValueField='N' [dataSource]='workflowList' formControlName="formWorkflow" [IsCascading]='true' [defaultValue]="selectedWorkflownumber" (valueChange)='selectedworkflowvalue($event)' (click)="closeworkflowTab($event)">
                                  </EIPAutoComplete>
                              </form>
                          </div>
                          <div class='col-xl-3 col-lg-3 col-md-4 col-sm-6 col-xs-12'>
                              <div>
                                  <span>
                                      <button mat-raised-button color="primary" (click)="addDocFromGrid()"> <i class="fa fa-link" aria-hidden="true" title="Link Document"></i>&nbsp;&nbsp;Link</button>
                                  </span>
                              </div>
                          </div>
                      </div> -->
                  </div>
                  <div class="row m-0">
                      <kendo-grid [style.maxHeight]="250" #docgrid [kendoGridBinding]="standardList" [filterable]="enableFilter" [selectable]="true" [pageSize]="15" [pageable]="true" (selectionChange)="onSelectionChange($event)" [skip]="skip" [sortable]="true" [reorderable]="true" [resizable]="true" [scrollable]="true" (pageChange)="pageChange($event)" [height]="550">
                          <ng-template kendoPagerTemplate>
                              <div class="k-pager-left">
                                  <kendo-pager-info></kendo-pager-info>
                              </div>
                              <div class="k-pager-right">
                                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                                  <kendo-pager-input></kendo-pager-input>
                                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
                              </div>
                          </ng-template>
                          <ng-template kendoGridToolbarTemplate>
                              <div class="k-grid-toolbar-content d-flex">
                                  <div class="flex-grow-1 mat-panel-headerbar"></div>
                                  <!-- <div class="pagination-container">
                                      <p id="lblShowDetails">Show</p>
                                      <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                                      </kendo-pager-page-sizes>
                                      <span>Items</span>
                                  </div> -->
                                  <!-- <div class="divider-container d-none d-md-block" id="imgDivider">
                                      <span></span>
                                  </div> -->
                                  <div class="icons-container">
                                      <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                                      <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                          <div class="icon-wrap" *ngIf="isCommonProject">
                                              <i class="fa fa-plus-circle" aria-hidden="true" title="Create" (click)="createdocument()"></i>
                                          </div>
                                          <div class="icon-wrap" *ngIf="!isCommonProject">
                                            <i class="fa fa-chain" aria-hidden="true" title="Link" (click)="addDocFromGrid()"></i>
                                          </div>
                                          <div class="icon-wrap">
                                              <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                                          </div>
                                      </div>
                                  </div>
                                  <div class="divider-container d-none d-md-block" id="imgDivider">
                                    <span></span>
                                  </div>
                                  <div class="pagination-container">
                                    <p id="lblShowDetails">Show</p>
                                    <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                                    </kendo-pager-page-sizes>
                                    <span>Items</span>
                                  </div>
                                </div>
                          </ng-template>
                          <kendo-grid-checkbox-column showSelectAll="true" [width]="50" *ngIf="!isCommonProject"> </kendo-grid-checkbox-column>
                          <kendo-grid-column title="Sl.No." filterable="false" [width]="50" *ngIf="isCommonProject">
                              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                  {{rowIndex + 1}}
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Document No" field="doc_No" [width]="150">
                              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                                  <i aria-hidden="true"  class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="Attachment" (click)="viewAttachmentClick(dataItem)"></i>
                                  <i class="fa fa-upload fs-20 eip-pr-10" title="Upload" (click)="uploadattachmentClick(dataItem)" style="cursor:pointer; font-size: 15px; color: #1579ab !important;" *ngIf="isCommonProject" aria-hidden="true"></i>
                                  <span class="no-wrap eip-link" eipTooltip="{{dataItem.doc_No}}" eipTooltipPosition="auto">
                                      {{dataItem.doc_No}}</span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Title" field="doc_Title" [width]="300">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.doc_Title}}" eipTooltipPosition="auto">
                                      {{dataItem.doc_Title}}
                                  </span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Revision No" field="revision_No" [width]="80">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.revision_No}}" eipTooltipPosition="auto">
                                      {{dataItem.revision_No}}
                                  </span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Discipline" field="discipline" [width]="100">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.discipline}}" eipTooltipPosition="auto">
                                      {{dataItem.discipline}}
                                  </span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Print Size" field="print_Size" [width]="80">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.print_Size}}" eipTooltipPosition="auto">
                                      {{dataItem.print_Size}}
                                  </span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Created By" field="created_By" [width]="100">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.created_By}}" eipTooltipPosition="auto">
                                      {{dataItem.created_By}}
                                  </span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Created On" [width]="100" [minResizableWidth]="100">
                              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                                  <span class="no-wrap" eipTooltip="{{dataItem.created_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">
                                      {{dataItem.created_On | date:'dd-MMM-yyyy'}}
                                  </span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Supersede" [width]="50" *ngIf="isCommonProject">
                            <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                                <i class="fa fa-step-forward" title="Supersede" *ngIf="dataItem.is_Latest" style="cursor: pointer;" (click)="super_doc(dataItem)" aria-hidden="true"></i>
                            </ng-template>
                        </kendo-grid-column>
                      </kendo-grid>
                  </div>
              </div>
              <div [hidden]="isStandardDraw">
                  <div class="row m-0">
                      <kendo-grid [style.maxHeight]="250" #docgrid [kendoGridBinding]="linkedList" [filterable]="enableFilter" [selectable]="true" [pageSize]="15" [pageable]="true" [skip]="skip" [sortable]="true" [reorderable]="true" [resizable]="true" [scrollable]="true" [height]="550">
                          <ng-template kendoPagerTemplate>
                              <div class="k-pager-left">
                                  <kendo-pager-info></kendo-pager-info>
                              </div>
                              <div class="k-pager-right">
                                  <kendo-pager-prev-buttons></kendo-pager-prev-buttons>
                                  <kendo-pager-input></kendo-pager-input>
                                  <kendo-pager-next-buttons></kendo-pager-next-buttons>
                              </div>
                          </ng-template>
                          <ng-template kendoGridToolbarTemplate>
                              <div class="k-grid-toolbar-content d-flex">
                                  <div class="flex-grow-1 mat-panel-headerbar"></div>
                                  <div class="pagination-container">
                                      <p id="lblShowDetails">Show</p>
                                      <kendo-pager-page-sizes [pageSizes]="[15, 30, 50, 100, {text: 'All',value: 'all'}]" id="ddlRecordsperPage">of
                                      </kendo-pager-page-sizes>
                                      <span>Items</span>
                                  </div>
                                  <div class="divider-container d-none d-md-block" id="imgDivider">
                                      <span></span>
                                  </div>
                                  <div class="icons-container">
                                      <i class="fa fa-ellipsis-v d-block d-md-none" aria-hidden="true" [ngClass]="{'ellipsis-active' : toggleListIcons}" (click)="toggleListIcons = !toggleListIcons"></i>
                                      <div class="d-none d-md-flex align-items-md-center" [ngClass]="{'icons-list-type' : toggleListIcons}">
                                          <div class="icon-wrap">
                                              <i class="fa fa-filter" title="Filter" (click)="toggleFilter()" aria-hidden="true"></i>
                                          </div>
                                      </div>
                                  </div>
                              </div>
                          </ng-template>

                          <kendo-grid-column title="Sl.No." filterable="false" [width]="50">
                              <ng-template kendoGridCellTemplate let-dataItem="dataItem" let-rowIndex="rowIndex">
                                  {{rowIndex + 1}}
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Document No" field="doc_No" [width]="150">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <i aria-hidden="true"  class="fa fa-paperclip fs-16 eip-mr-5 eip-link" title="Attachment" (click)="viewLinkedAttachment(dataItem)"></i>
                                  <span class="no-wrap eip-link" eipTooltip="{{dataItem.doc_No}}" eipTooltipPosition="auto">
                                      {{dataItem.doc_No}}</span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Title" field="doc_Title" [width]="300">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.doc_Title}}" eipTooltipPosition="auto">
                                      {{dataItem.doc_Title}}
                                  </span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Revision No" field="revision_No" [width]="100">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.revision_No}}" eipTooltipPosition="auto">
                                      {{dataItem.revision_No}}
                                  </span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Discipline" field="discipline" [width]="100">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.discipline}}" eipTooltipPosition="auto">
                                      {{dataItem.discipline}}
                                  </span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Print Size" field="print_Size" [width]="100">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.print_Size}}" eipTooltipPosition="auto">
                                      {{dataItem.print_Size}}
                                  </span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Created By" field="created_By" [width]="100">
                              <ng-template kendoGridCellTemplate let-dataItem>
                                  <span class="no-wrap" eipTooltip="{{dataItem.created_By}}" eipTooltipPosition="auto">
                                      {{dataItem.created_By}}
                                  </span>
                              </ng-template>
                          </kendo-grid-column>
                          <kendo-grid-column title="Created On" [width]="80" [minResizableWidth]="80">
                              <ng-template kendoGridCellTemplate let-dataItem="dataItem">
                                  <span class="no-wrap" eipTooltip="{{dataItem.created_On | date:'dd-MMM-yyyy'}}" eipTooltipPosition="auto">
                                      {{dataItem.created_On | date:'dd-MMM-yyyy'}}
                                  </span>
                              </ng-template>
                          </kendo-grid-column>
                      </kendo-grid>
                  </div>
              </div>
          </div>
      </section>
  </div>
</div>